import(/* webpackMode: "eager" */ "/app/apps/publicWeb/src/app/global-error.tsx");
